// extracted by mini-css-extract-plugin
module.exports = {"shadow":"df5dab2e92--shadow--2GMMP","container":"df5dab2e92--container--3pvY4"};